import ChangeKeywordsExclusions from 'components/Dashboard/utilities/changeKeywordExclusions';
import ChangeKeywordsCategory from 'components/Dashboard/utilities/changeKeywordsCategory';
import ChangeSearchQuery from 'components/Dashboard/utilities/changeSearchQuery';
import useSelectedCountriesFilters from 'components/Dashboard/Analytics/useSelectedCountriesFilters';

const useAnalyticsApiHelpers = (props) => {
  const { getParliamentaryPositionsFilters } = useSelectedCountriesFilters(props);

  const addCommonAnalyticsProperties = (baseProps, { topic, freeSearch, teamId, stakeholderId, tweets }) => {
    let requestProperties = { ...baseProps };
    if (topic?.prospective) {
      const { keywords, andKeywords, keywordExclusions } = topic;
      requestProperties = {
        ...requestProperties,
        query: ChangeKeywordsCategory(keywords),
        andQueries: ChangeKeywordsExclusions(andKeywords),
        mustNotQueries: ChangeKeywordsExclusions(keywordExclusions),
      };
    } else if (freeSearch) {
      requestProperties = {
        ...requestProperties,
        query: ChangeSearchQuery(freeSearch),
      };
    } else if (topic?.id) {
      requestProperties = {
        ...requestProperties,
        keywordListId: topic.id,
      };
    }
    if (stakeholderId) {
      const stakeholderIdField =
        baseProps.type?.toLowerCase() === 'tweet'
          ? 'contactId'
          : baseProps.type === 'WrittenQuestion'
            ? 'questionByContactId'
            : 'contactIds';
      requestProperties = {
        ...requestProperties,
        filters: [
          ...(requestProperties.filters || []),
          { field: stakeholderIdField, value: stakeholderId, operator: 'str_eq' },
        ],
      };
    }
    if (teamId) {
      requestProperties = {
        ...requestProperties,
        teamId,
      };
    }
    return requestProperties;
  };

  const createAnalyticsPathname = ({ teamId, freeSearch, conditionOfPublicApi, topic }) => {
    return `/api/${teamId ? 'widget' : 'graph-data'}/${
      freeSearch && conditionOfPublicApi ? 'public-' : ''
    }date-histogram${!!topic && !topic?.prospective && !freeSearch ? '-by-keyword-list' : ''}`;
  };

  const parliamentaryPositionsFilters = getParliamentaryPositionsFilters();

  return { addCommonAnalyticsProperties, createAnalyticsPathname, parliamentaryPositionsFilters };
};

export default useAnalyticsApiHelpers;
